<template>
    <v-slide-group class="pa-4" show-arrows ref="list">
        <template v-for="product in products">
            <v-slide-item :key="product._id">
                <v-card v-bind="{ width }" elevation="0" rounded="0">
                    <!-- <v-col cols="6" sm="4" md="3" > -->
                    <slot name="list-item" :product="product" />
                    <!-- </v-col> -->
                </v-card>
            </v-slide-item>
        </template>
    </v-slide-group>
</template>

<script>
export default {
    props: {
        value: { type: Number, default: 1 },
        pageCount: { type: Number, default: 0 },
        limit: { type: Number, default: 10 },
        products: { type: Array, default: [] },
    },
    data() {
        return {
            page: this.$props.value || 1,
            wrapper: {
                width: 2000,
            },
        };
    },
    computed: {
        itemsPerView() {
            switch (this.$vuetify.breakpoint.name) {
                case "xl":
                case "lg":
                case "md": {
                    return 4;
                }
                case "sm": {
                    return 3;
                }
                default: {
                    return 2;
                }
            }
        },
        width() {
            return this.wrapper.width / this.itemsPerView;
        },
    },
    mounted() {
        console.log(this.$vuetify);
        window.addEventListener("resize", this.onResize);
        this.onResize();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            let intervalId = setInterval(() => {
                /** @type {HTMLElement} */
                let list = this.$refs["list"]?.$el;
                if (!list) return;

                let wrapper = list.getElementsByClassName("v-slide-group__wrapper")?.[0];
                if (!wrapper) return;

                this.wrapper.width = wrapper.getBoundingClientRect()?.width;

                clearInterval(intervalId);
            }, 10);
        },
    },
};
</script>
